import { render, staticRenderFns } from "./price_edit_dialog.vue?vue&type=template&id=02f47aad&scoped=true"
import script from "./price_edit_dialog.vue?vue&type=script&lang=js"
export * from "./price_edit_dialog.vue?vue&type=script&lang=js"
import style0 from "./price_edit_dialog.vue?vue&type=style&index=0&id=02f47aad&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f47aad",
  null
  
)

export default component.exports